import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { days } from '@libs/@core/components/date-picker/utils/dateUtils';
var BaseCalendarDayHeader = function () {
    return (_jsx("div", { className: 'grid grid-cols-7 gap-1 mb-1', children: days.map(function (day) { return (_jsx("div", { className: 'text-center text-xs font-medium text-gray-500', children: day }, day)); }) }));
};
export default memo(BaseCalendarDayHeader);
